import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getPermissionsListFetchSuccess, getPermissionsListFetchFailure } from './reducer';
import { PermissionsListResType } from 'src/types/permissionsList';

const getPermissionsListFetchRequest = async () => {
    const res = await api('get', 'api/secure/permissions');
    return res.data.data;
};

function* getPermissionsListFetch(action: { type: string }) {
    try {
        const response: PermissionsListResType = yield call((): any => getPermissionsListFetchRequest());
        yield put(getPermissionsListFetchSuccess(response));
    } catch (error) {
        yield put(getPermissionsListFetchFailure({ error }));
    }
}

export function* getPermissionsListFetchWatch() {
    yield takeEvery('permissionsList/getPermissionsListFetch', getPermissionsListFetch);
}
